export const types = {
  DISCOVER: 'auth/discover/DISCOVER',
  DISCOVER_SUCCESS: 'auth/discover/DISCOVER_SUCCESS',
  DISCOVER_ERROR: 'auth/discover/DISCOVER_ERROR',
  DISCOVER_RESET: 'auth/discover/DISCOVER_RESET',
};

export const discover = {
  error: (error) => ({
    type: types.DISCOVER_ERROR,
    payload: error,
  }),
  request: ({ email, next }) => ({
    type: types.DISCOVER,
    payload: { email, next },
  }),
  // Pass { email } when routing to the password step; omit payload for SSO/OIDC redirects.
  success: (payload = {}) => ({
    type: types.DISCOVER_SUCCESS,
    payload,
  }),
  reset: () => ({
    type: types.DISCOVER_RESET,
  }),
};
